import { render, staticRenderFns } from "./TypeDropdown.vue?vue&type=template&id=6b367be0"
import script from "./TypeDropdown.vue?vue&type=script&lang=js"
export * from "./TypeDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports